// Imports
import BaseNotifyAlert from './BaseNotifyAlert.vue'
import BaseNotifyPlatformChange from './BaseNotifyPlatformChange.vue'
import EventBus from './EventBus'

export default {
  install (Vue) {
    // Base Notify Alert Component
    Vue.component('BaseNotifyAlert', BaseNotifyAlert)
    Vue.component('BaseNotifyPlatformChange', BaseNotifyPlatformChange)

    // Show Alert Handle
    Vue.prototype.$showAlert = (alert) => {
      EventBus.$emit('showAlert', alert)
    }
    // Show Platform Change Notification
    Vue.prototype.$showPlatformChange = (platform) => {
      EventBus.$emit('showPlatformChange', platform)
    }
  }
}
